import { topicTags } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 scroll-mt-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">社区热议</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">漫画爱好者正在热烈讨论的话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicTags.map((tag) => (
            <span key={tag.id} className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-secondary-300 hover:bg-secondary-50 transition-all cursor-pointer">
              <div className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50 transition-colors flex-shrink-0">
                <i className={`${tag.icon} text-xs`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{tag.label}</span>
              <span className="text-xs text-foreground-400">{tag.count}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}